import React from 'react';
import styles from './index.less';
import { TabButtonGroup } from './tab-button/tab-button-group';
import { ThemeList } from './theme-list/theme-list';
import { CLASSIC_KEY, CUSTOM_KEY } from '@src/slide/application/service/theme-color-manager/theme-config';
import { IThemeSelectItem } from '@src/slide/domain/ui-model/element-modeles/Interface/theme-model.interface';
import { IThemeColorManager } from '@src/slide/application/service/theme-color-manager/index.interface';
import { IMenuManager } from '@src/slide/application/service/menu-manager/menu-manager.interface';
import { IRightMenuManager } from '@src/slide/application/service/right-menu-manager/core/right-menu-manager.interface';
import { IDynamicService } from '@src/slide/infrastructure/module/independent/dynamic-loader/dynamic-service';

interface IThemeSelectListProps {
    selectedKey: string;
    themeColorManager?: IThemeColorManager;
    menuManager?: IMenuManager;
    rightMenuManager?: IDynamicService<IRightMenuManager>;
    handleThemeSelect(theme: IThemeSelectItem, selectedKey?: string): void;
}

interface IThemeSelectListState {
    themeType: string;
}

/**
 * 主题选择列表
 */
export class ThemeSelectList extends React.Component<IThemeSelectListProps, IThemeSelectListState> {
    private listContainerRef: HTMLDivElement | null;
    constructor(props) {
        super(props);
        this.state = {
            themeType: props?.themeColorManager?.isOpenCustomPanel ? CUSTOM_KEY : CLASSIC_KEY,
        };
    }

    public render() {
        return <div className={styles['theme-color-container']}>
            {/* <div className={styles['theme-preview-title-container']}>{ i18n.t('主题色') }</div> */}
            <div className={styles['theme-color-list-container']}>
                <div className={styles['theme-tab-button-container']}>
                    <TabButtonGroup
                        themeType={this.state.themeType}
                        onThemeTypeChange={(themeType) => {
                            this.setState({
                                themeType,
                            });
                            this.handleThemeListChange();
                        }} />
                </div>
                <div ref={(ref) => {
                    this.listContainerRef = ref;
                }} className={styles['theme-tab-content-container']}>
                    <ThemeList
                        themeColorManager={this.props.themeColorManager}
                        rightMenuManager={this.props.rightMenuManager}
                        menuManager={this.props.menuManager}
                        isCustom={this.state.themeType === CUSTOM_KEY}
                        selectedKey={this.props.selectedKey}
                        handleThemeSelect={this.props.handleThemeSelect}
                        themeType={this.state.themeType} />
                </div>
            </div>
        </div>;
    }

    /**
     * 切页时，列表滚动归位
     */
    public handleThemeListChange = () => {
        if (this.listContainerRef?.scrollTop) {
            this.listContainerRef.scrollTop = 0;
        }
    };
}
